import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { emailConfigApi } from '../../../api/emailConfigApi';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { eEmailConfigActionTypeIds, IDmEmailConfigActionTypes } from './../../action-types/email/IDmEmailConfigActionTypes';
import { IDmEmailConfig } from '../../../models/response/email/IDmEmailConfig';
import { apiWrapper } from '../../../api/apiWrapper';
export function* emailConfigSaga(): any {
    yield takeLatest(eEmailConfigActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eEmailConfigActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eEmailConfigActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(emailConfigApi.selectAll)
    if (res.is_success) {
        yield put(actions.emailWrapper.dmEmailConfig.LOAD_SUCCCES(res.data))
    } else {
        yield put(actions.emailWrapper.dmEmailConfig.LOAD_ERROR(res.message ?? "Error"))
    }
}
function* saveWorker(action: IDmEmailConfigActionTypes): any {
    const payload: IDmEmailConfig = action.payload as IDmEmailConfig;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.email.emailConfig.update, payload)
    } else {
        res = yield call(apiWrapper.email.emailConfig.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.emailWrapper.dmEmailConfig.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.emailWrapper.dmEmailConfig.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IDmEmailConfigActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.email.emailConfig.delete, payload)
    if (res.is_success) {
        yield put(actions.emailWrapper.dmEmailConfig.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.emailWrapper.dmEmailConfig.DELETE_ERROR(res.message ?? "Error"))
    }
}
